import React from 'react';
import { useNavigate } from 'react-router-dom';
import HerbalLeaves from "../../../Assests/HerbImgList/HerbLeaves.svg";
import BannerBottom from "../../../Assests/HerbImgList/BannerBottom.svg";
import lehyas from "../../../Assests/HerbImgList/HerbalLehyas.svg";
import tablets from "../../../Assests/HerbImgList/HerbalTablets.svg";
import churnas from "../../../Assests/HerbImgList/Churanams.svg";
import lehyam from "../../../Assests/HerbImgList/HerbalTailam.svg";

const CATEGORIES_LIST = [
  {
    id: 'AsavamsAristas',
    name: 'Asavams & Aristas',
    img: tablets,
  },
  {
    id: 'Churnams',
    name: 'Churnams',
    img: churnas,
  },
  {
    id: 'Tailam',
    name: 'Tailam',
    img: lehyam,
  },
  {
    id: 'Raw Herbs',
    name: 'Raw Herbs',
    img: HerbalLeaves,
  },
  {
    id: 'Lehyams',
    name: 'Lehyams',
    img: lehyas,
  },
];

const ProductCategories = ({ currType, handleProductCategories, isLoading }) => {
  const navigate = useNavigate();

  const handleViewAllClick = (event) => {
    event.preventDefault();
    navigate('/product');
    window.scrollTo(0, 0);
  };

  return (
    <section className="bg-gradient-to-b from-[#9D7201] to-[#866100] w-full shadow-inner">
      <div className="container mx-auto py-12 px-4">
        <div className="text-center mb-8">
          <span className="text-amber-200 uppercase font-bold text-xs tracking-widest block mb-1">
            Carefully Curated Classical Categories
          </span>
          <h2 className="md:text-3xl text-2xl font-serif font-bold text-white mb-2">
            OUR PRODUCTS
          </h2>
          <p className="text-amber-100/90 text-sm md:text-base font-light max-w-md mx-auto">
            The herbal choice is a healthy choice for mind, body, and spirit
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-6 max-w-5xl mx-auto">
          {CATEGORIES_LIST.map((cat) => {
            const isSelected = currType === cat.id;
            return (
              <div
                key={cat.id}
                onClick={() => handleProductCategories(cat.id)}
                className={`group flex flex-col items-center justify-between p-4 rounded-2xl cursor-pointer transition-all duration-300 transform ${
                  isSelected
                    ? 'bg-white/20 backdrop-blur-md border-2 border-white shadow-xl scale-105 ring-4 ring-amber-400/30'
                    : 'bg-white/10 hover:bg-white/15 border border-white/20 hover:scale-102 shadow-sm'
                }`}
              >
                <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center p-2 rounded-xl bg-white/15 group-hover:bg-white/25 transition-all mb-3">
                  <img
                    src={cat.img}
                    alt={cat.name}
                    className="max-h-full max-w-full object-contain filter drop-shadow-md group-hover:scale-110 transition-transform duration-200"
                  />
                </div>
                <p
                  className={`text-center text-xs md:text-sm font-semibold transition-all line-clamp-1 ${
                    isSelected
                      ? 'text-white font-bold drop-shadow-md'
                      : 'text-amber-100 group-hover:text-white'
                  }`}
                >
                  {cat.name}
                </p>
                {isSelected && (
                  <span className="w-2 h-2 rounded-full bg-white mt-1.5 shadow-glow" />
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="relative bg-[#866100] md:h-[180px] h-[110px] flex justify-center items-center overflow-hidden">
        <div className="absolute top-0 w-full h-full opacity-90 pointer-events-none">
          <img src={BannerBottom} alt="/" className="w-full h-full object-cover object-top" />
        </div>
        <div className="relative z-10">
          <button
            onClick={handleViewAllClick}
            className="h-12 bg-white hover:bg-amber-50 text-[#866100] px-8 rounded-full font-bold text-sm md:text-base shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5 cursor-pointer"
          >
            View All Products →
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
